import React from 'react';
import { Check } from 'lucide-react';

const MenuItem = ({ title, onClick, checked, children }) => {

    const handleClick = (e) => {
        onClick && onClick(e, this);
    }

    return (
        <button onClick={handleClick} role="menuitem"
            className="w-full text-left px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-600 flex items-center justify-between">
            <span className="flex items-center">
                {title}{children}
            </span>
            {checked === true && <Check className="h-4 w-4" />}
        </button>
    )
}

export default MenuItem
